import {getSite} from '@/api/sites';
import {useQuery} from '@tanstack/react-query';

export function useSite(siteId: string) {
    return useQuery({
        queryKey: ['site', siteId],
        queryFn: () => getSite(siteId),
        enabled: !!siteId
    });
}
